// Shared formatting helpers (were copy-pasted per component before 2026-07-02).

// @ts-ignore — plain JS one door shared with scripts/wa-worker.mjs
import { fmtStars } from './rawRating.mjs';

/** Rating for display (Founder LAW 04/10/26): the raw Google rating out of 5, one decimal — "4.9", "5.0" (lib/rawRating.mjs). */
export function fmtRating(n: number): string {
  return fmtStars(n);
}
